import { useTranslation } from 'react-i18next';
import { PropsWithChildren } from 'react';
import { classNames } from '@utils/classNames';
import { Link } from '@components/atoms/Link';
import { Logo } from '@components/atoms/Logo';
import { ExternalLinks } from '@src/routes/paths';

function FooterLink({ to, label }: { to: string; label: string }) {
  return (
    <Link to={to} className="text-center text-dark text-sm font-light">
      {label}
    </Link>
  );
}

function FooterLinkContainer({ children }: PropsWithChildren) {
  return (
    <div className="flex flex-col space-y-1.5 justify-start h-full">
      {children}
    </div>
  );
}

export function Footer({ className }: { className?: string }) {
  const { t } = useTranslation('view', { keyPrefix: 'footer' });
  return (
    <footer className={classNames(className, 'pt-8 pb-16')}>
      <span className="flex mt-8 mb-10 w-full items-center">
        <div className="grow border border-dark h-0 mx-5" />
        <Logo />
        <div className="grow border border-dark h-0 mx-5" />
      </span>
      <div className="w-full bg-grey3light grid grid-cols-1 space-y-8 md:grid-cols-4 md:space-y-0 rounded-t-bonusLarge items-center py-5">
        <FooterLinkContainer>
          <FooterLink
            to={ExternalLinks.FOOTER_SHIPPING}
            label={t('shipping')}
          />
          <FooterLink
            to={ExternalLinks.FOOTER_TEST_RESULT}
            label={t('testResult')}
          />
          <FooterLink to={ExternalLinks.FOOTER_CONTACT} label={t('contact')} />
        </FooterLinkContainer>
        <FooterLinkContainer>
          <FooterLink to={t('dataPrivacyUrl')} label={t('dataPrivacy')} />
          <FooterLink to={ExternalLinks.FOOTER_IMPRINT} label={t('imprint')} />
          <FooterLink to={t('agbUrl')} label={t('agb')} />
          <FooterLink
            to={ExternalLinks.FOOTER_ACCREDITATION}
            label={t('accreditation')}
          />
        </FooterLinkContainer>
        <FooterLinkContainer>
          <FooterLink to={ExternalLinks.FOOTER_BLOG} label={t('blog')} />
          <FooterLink to={ExternalLinks.FOOTER_FAQ} label={t('faq')} />
          <FooterLink
            to={ExternalLinks.FOOTER_TESTCOMPARE}
            label={t('testCompare')}
          />
          <FooterLink
            to={ExternalLinks.FOOTER_AFFILIATE}
            label={t('affiliate')}
          />
        </FooterLinkContainer>
        <FooterLinkContainer>
          <FooterLink
            to={ExternalLinks.FOOTER_EXPERIENCE}
            label={t('experience')}
          />
          <FooterLink
            to={ExternalLinks.FOOTER_WATER_WIKI}
            label={t('waterWiki')}
          />
          <FooterLink
            to={ExternalLinks.FOOTER_MOLD_WIKI}
            label={t('moldWiki')}
          />
          <FooterLink
            to={ExternalLinks.FOOTER_ASBESTOS}
            label={t('asbestos')}
          />
        </FooterLinkContainer>
      </div>
    </footer>
  );
}
